module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sense-main"
  }, [_c('div', {
    staticClass: "sense-breadcrumb"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/order'
      }
    }
  }, [_vm._v(_vm._s(_vm.orderNo))]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("订单详情")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sense-table-list sense-table-ellipsis sense-detail"
  }, [_c('div', {
    staticClass: "sense-detail-block"
  }, [_c('h3', [_vm._v("概要")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "110px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单编号："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.orderNo))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "产生原因："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("reasonFilter")(_vm.orderDetailObj.reason)))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单状态："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("statusFilter")(_vm.orderDetailObj.status)))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "创建时间："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.createAt))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "支付时间："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.payAt))])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sense-detail-block"
  }, [_c('h3', [_vm._v("产品信息")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "110px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "产品分类："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("categoryNoFilter")(_vm.orderDetailObj.categoryNo)))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品名称："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.productName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数量："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.buyCount))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "价格："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.price))])])], 1), _vm._v(" "), (_vm.orderDetailObj.productInfo) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [(_vm.orderDetailObj.categoryNo == 1) ? _c('el-form-item', {
    attrs: {
      "label": "许可形式："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("licenseFormFilter")(_vm.orderDetailObj.productInfo.licenseForm)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.categoryNo == 1) ? _c('el-form-item', {
    attrs: {
      "label": "许可周期："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("licensePeriodFilter")(_vm.orderDetailObj.productInfo.licensePeriod, _vm.orderDetailObj.productInfo.isForever)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.productInfo.licenseForm == 1) ? _c('el-form-item', {
    attrs: {
      "label": "使用计数："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.productInfo.useCount ? _vm.orderDetailObj.productInfo.useCount : '--'))])]) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.productInfo.licenseForm == 2 && _vm.orderDetailObj.productInfo.platform == 7) ? _c('el-form-item', {
    attrs: {
      "label": "许可类型："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("concurrentFilter")(_vm.orderDetailObj.productInfo.hasConcurrent, _vm.orderDetailObj.productInfo.concurrentType, _vm.orderDetailObj.productInfo.concurrent)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.productInfo.licenseForm == 2 && ((_vm.orderDetailObj.productInfo.platform == 7 && _vm.orderDetailObj.productInfo.hasConcurrent == false) || (_vm.orderDetailObj.productInfo.platform & 24) > 0)) ? _c('el-form-item', {
    attrs: {
      "label": "同时绑定数："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.productInfo.bindLimit))])]) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.productInfo.licenseForm == 2 && _vm.orderDetailObj.productInfo.hasConcurrent == false && _vm.orderDetailObj.productInfo.platform == 7) ? _c('el-form-item', {
    attrs: {
      "label": "累积绑定数："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.productInfo.maxBound))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.productInfo) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [(_vm.orderDetailObj.categoryNo == 1 && _vm.orderDetailObj.productInfo.licenseForm == 2) ? _c('el-form-item', {
    attrs: {
      "label": "系统平台："
    }
  }, [(_vm.orderDetailObj.productInfo.platform == 7) ? _c('div', {
    staticClass: "sense-text",
    staticStyle: {
      "position": "relative",
      "top": "-2px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t传统 (\n\t\t\t\t\t\t\t\t\t"), _c('em', {
    staticClass: "ssicon ss-windows",
    attrs: {
      "title": "Windows"
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "ssicon ss-linux",
    attrs: {
      "title": "Linux"
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "ssicon ss-mac",
    attrs: {
      "title": "Mac"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), ((_vm.orderDetailObj.productInfo.platform & 24) > 0) ? _c('div', {
    staticClass: "sense-text",
    staticStyle: {
      "position": "relative",
      "top": "-2px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t智能(\n\t\t\t\t\t\t\t\t\t"), _c('em', {
    staticClass: "ssicon ss-android",
    attrs: {
      "title": "Android"
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "arm-linux-icon",
    attrs: {
      "title": "ARM Linux"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.categoryNo == 1) ? _c('el-form-item', {
    attrs: {
      "label": "许可数量："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("commonFilter")(_vm.orderDetailObj.productInfo.licenseCount, _vm.orderDetailObj.productInfo.hasLicenseCount)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.categoryNo == 2) ? _c('el-form-item', {
    attrs: {
      "label": "更新次数："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("commonFilter")(_vm.orderDetailObj.productInfo.updateCount, _vm.orderDetailObj.productInfo.hasUpdateCount)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.categoryNo == 3) ? _c('el-form-item', {
    attrs: {
      "label": "计费方式："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("chargeModeFilter")(_vm.orderDetailObj.productInfo.chargeMode)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.categoryNo == 3 && _vm.orderDetailObj.productInfo.chargeMode == 1) ? _c('el-form-item', {
    attrs: {
      "label": "升级次数："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.productInfo.upgradeCount))])]) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.categoryNo == 3 && _vm.orderDetailObj.productInfo.chargeMode == 2) ? _c('el-form-item', {
    attrs: {
      "label": "硬件锁数量："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.productInfo.dongleCount))])]) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.categoryNo == 3 && _vm.orderDetailObj.productInfo.chargeMode == 2) ? _c('el-form-item', {
    attrs: {
      "label": "硬件锁周期："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("donglePeriodFilter")(_vm.orderDetailObj.productInfo.donglePeriod)))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "套餐有效期："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("packagePeriodFilter")(_vm.orderDetailObj.productInfo.packagePeriod)))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "套餐失效日期："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("expireTimeFilter")(_vm.orderDetailObj.productInfo.expireTime)))])])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sense-detail-block"
  }, [_c('h3', [_vm._v("结算信息")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "110px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "应付金额："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.amount))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "实付金额："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.deductAmount))])])], 1)], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "all-dialog"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33b255a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OrderDetail.vue
// module id = 579
// module chunks = 1